<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="100px">
        <el-form-item label="门店名称">
          <el-input
            placeholder="请输入"
            v-model="searchData.storeName"
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            placeholder="请输入"
            v-model="searchData.orderNo"
            clearable
            class="input-with-select"
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-date-picker
            style="width: 300px"
            v-model="searchData.settleDate"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结算状态">
          <el-select
            v-model="searchData.settleStatus"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式">
          <el-select
            v-model="searchData.settleType"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in payMethodsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝交易号">
          <el-input
              placeholder="请输入"
              v-model="searchData.openTradeNo"
              clearable
              size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="header-btn">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.finance_store_settlement_export)"
        style="margin-bottom: 20px"
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="downloadExcel"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <SettleDialog
      :orderNo="row.orderNo"
      :visible.sync="row.visible"
      :settleType="row.settleType"
      @ok="ok"
    />

    <el-dialog
      :visible="cancelForm.visible"
      title="提醒"
      width="500px"
      align-center
      :show-close="false"
    >
      <span>确定要取消该笔打款吗？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="cancelForm.visible = false">取消</el-button>
          <el-button type="primary" @click="handleCancel">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getFinanceOrderListAPI,
  exportAPI,
  downloadReceiptAPI,
  downloadReceiptPdf,
  cancelSettleAPI,
} from "./api";
import SettleDialog from "./settleDialog.vue";
import { dateFormat } from "@/utils";
import {
  getWithholdChannelText,
  getWithholdChannelType,
  shouldShowWithholdChannel,
} from "@/enum/dict/withholdChannel";

const columns = [
  {
    label: "门店名称",
    prop: "storeName",
    minWidth: "220",
    customRender(h, row) {
      return <p>{row["storeName"]}</p>;
    },
  },
  {
    label: "客户姓名",
    prop: "memberName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["memberName"]}</p>;
    },
  },
  {
    label: "订单信息",
    prop: "orderNo",
    minWidth: "280",
    customRender(h, row) {
      return (
        <div>
          <div>订单号：{row["orderNo"]}</div>
          <div>
            订单类型：
            <el-tag v-show={row["orderType"] == 2} type="warning" size="mini">
              门店订单
            </el-tag>
            <el-tag
              v-show={row["orderType"] == 4}
              color="#ffcccc54"
              style="color:#ff7744;border-color:#ffcccc54"
              size="mini"
            >
              电车订单
            </el-tag>
            <el-tag
              v-show={shouldShowWithholdChannel(row["withholdChannel"])}
              type={getWithholdChannelType(row["withholdChannel"])}
              size="mini"
              style="margin-left: 5px"
            >
              {getWithholdChannelText(row["withholdChannel"])}
            </el-tag>
          </div>
          <div>订单状态：{row["orderStatusName"]}</div>
          <div>下单时间：{row["orderCreateTime"]}</div>
        </div>
      );
    },
  },
  {
    label: "商品信息",
    prop: "goodsTitle",
    minWidth: "180",
    customRender(h, row) {
      return <p class="goods-info">{row["goodsTitle"]}</p>;
    },
  },
  {
    label: "商户",
    prop: "merchantName",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row.merchantName}</p>;
    },
  },
  {
    label: "结算方式",
    prop: "settleTypeName",
    minWidth: "130",
    customRender(h, row) {
      return <p>{row.settleTypeName}</p>;
    },
  },
  {
    label: "收款信息",
    prop: "settleAccountInfo",
    minWidth: "220",
    customRender(h, row) {
      if (row.settleType === 2) {
        return (
            <div>
              <p>收款账户姓名：{row.payeeIdName}</p>
              <p>支付宝账号：{row.payeeAlipayAccount}</p>
            </div>
        );
      } else if (row.settleType === 3) {
        return (
            <div>
              <p>法人姓名：{row.saLegalName}</p>
              <p>支付宝账号：{row.alipaySubMerchantLogonId}</p>
            </div>
        );
      } else {
        return <div>-</div>;
      }
    },
  },
  {
    label: "结算金额",
    minWidth: "100",
    prop: "settleAmount",
    customRender(h, row) {
      return <p>￥{row["settleAmount"]}</p>;
    },
  },
  {
    label: "结算时间",
    prop: "settleTime",
    minWidth: "160",
    customRender(h, row) {
      return <p>{row.settleTime}</p>;
    },
  },
  {
    label: "结算状态",
    prop: "settleStatusName",
    minWidth: "120",
    fixed: "right",
    customRender(h, row) {
      return (
        <p>
          <span v-show={row.settleStatus == 0 || row.settleStatus == 3}>{row["settleStatusName"]}</span>
          <span v-show={row.settleStatus == 1} style="color:green">
            {row["settleStatusName"]}
          </span>
          <div v-show={row.settleStatus == 2} style="color:red">
            <span style="margin-right: 5px;">{row["settleStatusName"]}</span>
            <el-tooltip effect="dark" placement="top-start">
              <template slot="content">
                <p style="width: 200px;">{row["settleRemark"] || "暂无信息"}</p>
              </template>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
        </p>
      );
    },
  },
  {
    label: "支付宝交易号",
    prop: "openTradeNo",
    minWidth: "160",
    customRender(h, row) {
      return <p>{row.openTradeNo}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "150",
    fixed: "right",
    align: "center",
    customRender(h, row) {
      return (
        <div>
          <el-link
            style="margin-right:10px"
            v-show={
              this.showOfflinePayBtn(row) &&
              this.isShowBtn(this.AUTH_BTN.finance_store_settlement_offline_payment)
            }
            underline={false}
            type="primary"
            onClick={() => this.showSettleDialog(row, 1)}
          >
            线下打款
          </el-link>

          <el-link
              style="margin-right:10px"
              v-show={
                  this.showCancelBtn(row) &&
                  this.isShowBtn(this.AUTH_BTN.finance_store_settlement_cancel)
              }
              underline={false}
              type="primary"
              onClick={() => this.showCancelDialog(row)}
          >
            取消打款
          </el-link>

          <el-link
            style="margin-right:10px"
            v-show={
              this.showRetryBtn(row) &&
              this.isShowBtn(this.AUTH_BTN.finance_store_settlement_retry)
            }
            underline={false}
            type="primary"
            onClick={() => this.showSettleDialog(row, 2)}
          >
            重试
          </el-link>

          <el-link
            style="margin:0 10px;"
            underline={false}
            type="primary"
            onClick={() => this.downloadReceipt(row)}
            v-show={
              this.showReceiptBtn(row) &&
              this.isShowBtn(this.AUTH_BTN.finance_store_settlement_receipt_download)
            }
          >
            下载回单
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "StoreSettlementList",
  mixins: [authBtnMixin],
  components: {
    SettleDialog,
  },
  data() {
    return {
      statusList: [
        {
          label: "待打款",
          value: 0,
        },
        {
          label: "打款成功",
          value: 1,
        },
        {
          label: "打款失败",
          value: 2,
        },
        {
          label: "已取消打款",
          value: 3,
        },
      ],
      payMethodsList: [
        {
          label: "线下打款",
          value: 1,
        },
        {
          label: "支付宝自动结算",
          value: 2,
        },
        {
          label: "大订单结算",
          value: 3,
        },
      ],
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        storeName: "", //门店名称
        orderNo: "", //订单号
        settleDate: "", //结算日期
        settleStatus: "", //结算状态
        settleType: "", //结算方式
        openTradeNo: "", //支付宝交易号
      },
      row: {},
      cancelForm: {
        dialog: false,
        orderNo: '',
      },
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    ok() {
      this.row.visible = false;
      this.getList();
    },
    showOfflinePayBtn(row) {
      return (
        (row.settleType === 1 && row.orderStatus >= 6 && (row.settleStatus === 0 || row.settleStatus === 2))
        || (row.settleType > 1 && row.settleStatus === 2)
      );
    },
    showCancelBtn(row) {
      return row.settleStatus === 0;
    },
    showReceiptBtn(row) {
      return (
          row.settleType === 2 && row.settleStatus === 1 && !this.ifOverTime(row)
      );
    },
    ifOverTime(row) {
      if (!row.settleTime) {
        return false;
      }
      const duration = dayjs().diff(dayjs(row.settleTime), "day");
      return duration > 365;
    },
    showRetryBtn(row) {
      return row.settleType === 2 && row.settleStatus === 2;
    },
    showSettleDialog(row, settleType) {
      this.row = {
        orderNo: row.orderNo,
        visible: true,
        settleType,
      };
    },
    showCancelDialog(row) {
      this.cancelForm = {
        visible: true,
        orderNo: row.orderNo,
      };
    },
    search() {
      this.getList();
    },
    async getList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchData,
      };
      if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
        params.leftSettleDate = this.searchData.settleDate[0];
        params.rightSettleDate = this.searchData.settleDate[1];
        params.settleDate = "";
      }
      const res = await getFinanceOrderListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    downloadExcel() {
      let params = { ...this.searchData };
      if (this.searchData.settleDate && this.searchData.settleDate.length > 0) {
        params.leftSettleDate = this.searchData.settleDate[0];
        params.rightSettleDate = this.searchData.settleDate[1];
        params.settleDate = "";
      }
      exportAPI(params);
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    async handleCancel() {
      await cancelSettleAPI({ orderNo: this.cancelForm.orderNo });
      this.cancelForm.orderNo = '';
      this.cancelForm.visible = false;
      this.getList();
      this.$message.success("操作成功");
    },
    async downloadReceipt(row) {
      const res = await downloadReceiptAPI({ orderNo: row.orderNo });
      downloadReceiptPdf(
        res.receiptFileUrl,
        `结算回单${row.orderNo}-${dateFormat()}.pdf`,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mr20 {
  margin-right: 20px;
}
.wrapper {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 200px;
        }
        .el-select {
          width: 200px;
        }
        .el-date-editor {
          width: 200px;
          /deep/.el-range-separator {
            width: auto;
          }
        }
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .header-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .goods-info {
    display: flex;
  }
}
</style>
